import {
  DASHBOARD_PREFIX,
  FX_DASHBOARD_PREFIX,
  FX_TRANSACTIONS_PREFIX,
  NOTIFICATIONS_PREFIX,
  OFFERS_PREFIX,
  PROFILE_PREFIX,
  PROMOTIONS_EVENTS_PREFIX,
  PROMOTIONS_PREFIX,
  RECEIVERS_PREFIX,
  REFERRAL_PREFIX,
  SECURITY_PREFIX,
  TRANSACTIONS_PREFIX,
} from 'constants/router';

import ExchangeIcon from 'assets/ver2/icons/header/exchange-icon.svg';
import ProfileIcon from 'assets/ver2/icons/header/profile-icon.svg';
import RemittanceIcon from 'assets/ver2/icons/header/remittance-icon.svg';
import TicketIcon from 'assets/ver2/icons/header/ticket-icon.svg';

export const NAV_MENUS_AUTHENTICATED = [
  {
    icon: RemittanceIcon,
    text: 'transactions_nav_label',
    href: `${DASHBOARD_PREFIX}`,
    href2: `${TRANSACTIONS_PREFIX}`,
    href3: `${RECEIVERS_PREFIX}`,
  },
  {
    icon: ExchangeIcon,
    text: 'fx_nav_label',
    href: `${FX_DASHBOARD_PREFIX}`,
    href2: `${FX_TRANSACTIONS_PREFIX}`,
  },
  {
    icon: TicketIcon,
    text: 'offer_nav_label',
    href: `${OFFERS_PREFIX}`,
    href2: `${PROMOTIONS_PREFIX}`,
    href3: `${PROMOTIONS_EVENTS_PREFIX}`,
  },
  {
    icon: ProfileIcon,
    text: 'profile_title',
    href: `${PROFILE_PREFIX}`,
    href2: `${SECURITY_PREFIX}`,
    href3: `${NOTIFICATIONS_PREFIX}`,
    href4: `${REFERRAL_PREFIX}`,
  },
];

export const NAV_MENUS_MOBILE_AUTHENTICATED = [
  {
    icon: RemittanceIcon,
    text: 'transactions_nav_label',
    href: `${DASHBOARD_PREFIX}`,
    href2: `${TRANSACTIONS_PREFIX}`,
    href3: `${RECEIVERS_PREFIX}`,
  },
  {
    icon: ExchangeIcon,
    text: 'fx_nav_label',
    href: `${FX_DASHBOARD_PREFIX}`,
    href2: `${FX_TRANSACTIONS_PREFIX}`,
  },
  {
    icon: TicketIcon,
    text: 'offer_nav_label',
    href: `${OFFERS_PREFIX}`,
    href2: `${PROMOTIONS_PREFIX}`,
    href3: `${PROMOTIONS_EVENTS_PREFIX}`,
  },
  {
    icon: ProfileIcon,
    text: 'profile_title',
    href: `${PROFILE_PREFIX}`,
    href2: `${SECURITY_PREFIX}`,
    href3: `${NOTIFICATIONS_PREFIX}`,
    href4: `${REFERRAL_PREFIX}`,
  },
];
